import {Component, OnInit} from '@angular/core';
import {
    DefaultGridButtons,
    GridColumn,
    MxCustomizer,
    MxGridButtonsConfig,
    MxGridCustomizerEvent,
    MxGridService,
    MxNotificationService,
    DocumentInfoObj,
    MxDownloadService, MxSelection
} from 'mx-core';
import {PrlTranslateService} from '../../../../../shared/services/prl-translate.service';
import {PrlAccountDataService} from '../../../../prl-dashboard/services/account/prl-account-data.service';
import {SelectionModel} from '@angular/cdk/collections';
import {HttpResponse} from '@angular/common/http';

@Component({
    selector: 'prl-documents',
    standalone: false,
    templateUrl: './prl-documents.component.html',
    styleUrl: './prl-documents.component.scss',
})
export class PrlDocumentsComponent implements OnInit, MxCustomizer<MxGridCustomizerEvent> {
    dateTimeFormat: string = 'yyyy-MM-dd HH:mm:ss';
    private gridColumns: GridColumn[] = [];
    private buttonsConfig: MxGridButtonsConfig;
    private gridService: MxGridService;

    constructor(protected readonly translateService: PrlTranslateService,
                private readonly dataService: PrlAccountDataService,
                private readonly downloadService: MxDownloadService,
                private readonly notificationService: MxNotificationService) {
    }

    ngOnInit(): void {
        this.gridColumns = [
            new GridColumn({
                field: 'name',
                label: () => this.translateService.getTranslatedLabel('label.modify.account.document.name'),
                sortable: true,
                hidden: false
            }),
            new GridColumn({
                field: 'description',
                label: () => this.translateService.getTranslatedLabel('label.modify.account.document.description'),
                sortable: true,
                hidden: false
            }),
            new GridColumn({
                field: 'creationDate',
                label: () => this.translateService.getTranslatedLabel('label.date.created'),
                sortable: true,
                hidden: false,
                dateTimeFormat: this.dateTimeFormat,
                type: 'date'
            }),
            new GridColumn({
                field: 'uploadedBy',
                label: () => this.translateService.getTranslatedLabel('label.portal.document.uploaded.by'),
                sortable: true,
                hidden: false
            })
        ];
        this.buttonsConfig = new MxGridButtonsConfig([
            [DefaultGridButtons.add, {
                label: () => this.translateService.getTranslatedLabel('label.modify.account.documentation.add'),
                icon: 'add',
                tooltip: () => this.translateService.getTranslatedLabel('label.modify.account.documentation.add'),
                className: 'mxs-button--secondary'
            }],
            [DefaultGridButtons.remove, {
                disabled: selection => MxSelection.noneOrMultipleSelection(selection, row => row.uploadedBy === 'agent', this.translateService.getTranslatedLabel('label.delete.message.on.agent.documents')),
                clickHandler: (selection: SelectionModel<DocumentInfoObj>) => {
                    this.dataService.removeDocument(selection.selected[0].id).subscribe(() => {
                        this.gridService.collection.doReload();
                    });
                }
            }],
            [DefaultGridButtons.edit, {hidden: true}],
            [DefaultGridButtons.view, {hidden: true}],
            [DefaultGridButtons.reload, {hidden: true}],
            ['download', {
                icon: 'download',
                tooltip: () => this.translateService.getTranslatedLabel('label.modify.account.download'),
                className: 'mxs-button--round mxs-button--secondary',
                disabled: MxSelection.noneOrMultipleSelection,
                clickHandler: (selection: SelectionModel<DocumentInfoObj>) => {
                    this.dataService.getDocument(selection.selected[0].id).subscribe((response: HttpResponse<Blob>) => {
                        if (response.ok) {
                            this.downloadService.saveResponseAsFile(response, response.headers.get('content-type'));
                        } else {
                            this.notificationService.showFailure('There’s an issue with downloading the file.', false);
                        }
                    });
                }
            }]
        ]);
    }

    onCustomize(event: MxGridCustomizerEvent): void {
        event
            .customizeLoadRowsOnStart(true)
            .customizeRestUrl('/account/documents')
            .customizeItemDetailsLink('/account/documents')
            .customizeColumns(this.gridColumns)
            .customizeActions(this.buttonsConfig)
            .customizeProps({
                selectionMode: 'single',
                readonly: true,
                showButtons: true,
                showColumns: false
            })
            .onSetUp(service => {
                this.gridService = service;
            });
    }

}
